$(function(){
  $('#pi-american_express').remove();
});

$('.Our-benefits .outer_loop_new').slick({
  dots: true,
  infinite: true,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1180,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 880,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 681,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// if(window.outerWidth < 989) {
// $('.home_video ').slick({
//   dots: false,
//   arrows: true,
//   infinite: true,
//   speed: 2000,
//   autoplay: true, 
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0723/4463/3592/files/play.png?v=1731919388'></button>",
//   nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0723/4463/3592/files/play.png?v=1731919388'></button>",
// });
// } 



$('.custom_testimonial .outer_loop_new').slick({
  dots: true,
  infinite: true,
  speed: 2000,
  autoplay: true, 
  arrows:false,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2,
        slidesToScroll:2,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow:1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('section.product-content-slider .outer_loop_new').slick({
  dots: false,
  infinite: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0723/4463/3592/files/play.png?v=1731919388'></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0723/4463/3592/files/play.png?v=1731919388'></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.product-benefits .main_meta_wrap').slick({
  dots: false,
  infinite: false,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1180,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        arrows: false,
        dots: false
      }
    },
    {
      breakpoint: 880,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        variableWidth: true
      }
    },
    {
      breakpoint: 681,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true
      }
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



////////////////////////////////////////////////////////////////


// const updatePrice = (wrapper, priceSelectors, selectedBag, currencySymbol = '$') => {
//   priceSelectors.forEach(selector => {
//     const span = wrapper.querySelector(selector);
//     if (span) {
//       // Skip if a span with class "u__d" already exists
//       if (span.querySelector('.u__d')) return;

//       // Match the number in the text (ignore currency symbols)
//       const priceMatch = span.textContent.trim().match(/[\d.,]+/);
//       if (priceMatch) {
//         // Remove commas and parse float
//         const numericPrice = parseFloat(priceMatch[0].replace(/,/g, ''));
//         if (!isNaN(numericPrice)) {
//           const newPrice = (numericPrice * selectedBag).toFixed(2);

//           span.innerHTML = `${currencySymbol}<span class="u__d">${newPrice}</span>`;

//         }
//       }
//     }
//   });
// };

// window.waitUntilSubscriptionLoads = function() {
//   let subscriptionAttempts = 0;

//   const subscriptionInterval = setInterval(() => {
//     // console.log('subscriptionAttempts', subscriptionAttempts);

//     const subscriptionWrapper = document.querySelector('.main_blossom .appstle_subscription_amount_wrapper');
//     const oneTimeWrapper = document.querySelector('.main_blossom .appstle_one_time_price_wrapper');

//     if (document.querySelector('.custom_variant_main') && subscriptionWrapper && oneTimeWrapper) {
//       clearInterval(subscriptionInterval);

//       // Corrected selector: added '.' before variant-selects
//       const selectedBag = Number(document.querySelector('variant-selects fieldset input:checked')?.value?.match(/\d+/)[0]) || 1;

//       const priceSelectors = [
//         '.appstle_subscription_amount',
//         '.appstle_subscription_amount-appstle-sr-only',
//         '.appstle_subscription_compare_amount',
//         '.appstle_subscription_compare_amount-appstle-sr-only'
//       ];

//       updatePrice(subscriptionWrapper, priceSelectors, selectedBag);
//       updatePrice(oneTimeWrapper, priceSelectors, selectedBag);

//       const subscriptionInputs = document.querySelectorAll('.main_blossom input');
//       subscriptionInputs.forEach(input => {
//         if (input.dataset.listenerAttached === 'true') return;

//         input.addEventListener('click', () => {
//           window.waitUntilSubscriptionLoads(); // Re-trigger after DOM updates
//         });

//         input.dataset.listenerAttached = 'true';
//       });

//     } else if (++subscriptionAttempts >= 200) {
//       clearInterval(subscriptionInterval);
//     }
//   }, 100);
// };
